import React, { useCallback, useState } from 'react';
import { usePostGeneralSupportChat, useSupportChats, useUpdateSupportChatFiles } from 'services/Data/SupportChatServices';
import SupportChatSharedContainer from './SupportChatSharedContainer';
import { useApprovalNotification } from 'services/Data/NotificationService';
import { useSelector } from 'react-redux';
import SupportFileUploadModal from './SupportFileUploadModal';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';

const Supports = () => {
  const accountReducer = useSelector(state => state.AccountReducer);

  useApprovalNotification(accountReducer.isLoggedIn, true);
  const { data: supportChats, isFetching: gettingSupportChats } = useSupportChats();
  const { mutateAsync: postGeneralSupportChat, isPending: isPostingGeneralSupportChat } = usePostGeneralSupportChat(
    accountReducer.isDemo,
  );
  const { mutateAsync: uploadChatFiles } = useUpdateSupportChatFiles();
  const [files, setFiles] = useState([]);
  const [openUploadModal, setOpenUploadModal] = useState();

  const handleCloseUploadModal = useCallback(() => setOpenUploadModal(false), []);
  const handleOpenUploadModal = useCallback(() => setOpenUploadModal(true), []);
  const handleAddFile = useCallback(files => setFiles(prev => [...prev, ...files]), []);
  const handleResetFile = useCallback(() => setFiles([]), []);

  const handleRemoveFile = useCallback(fileToRemove => setFiles(prev => prev.filter(f => f.path !== fileToRemove.path)), []);

  const handleAddNewNote = useCallback(
    newNote => {
      postGeneralSupportChat({ note: newNote }).then(({ data: note }) => {
        uploadChatFiles({ files, entityId: note.id, type: BlobStorageTypeEnumValue.SupportChat }).then(_ => {
          handleResetFile();
        });
      });
    },
    [postGeneralSupportChat, files, uploadChatFiles, handleResetFile],
  );
  return (
    <>
      <SupportFileUploadModal handleAddFile={handleAddFile} onClose={handleCloseUploadModal} show={openUploadModal} />
      <SupportChatSharedContainer
        gettingSupportChats={gettingSupportChats}
        supportChats={supportChats}
        handleAddNewNote={handleAddNewNote}
        isPostingGeneralSupportChat={isPostingGeneralSupportChat}
        openUploadFileModal={handleOpenUploadModal}
        files={files}
        handleRemoveFile={handleRemoveFile}
        handleResetFile={handleResetFile}
      />
    </>
  );
};

export default Supports;
